// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.VendorCustomTable_dashboard__WvJ0H {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.VendorCustomTable_dashboardContain__153fQ {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_dashboardContain__153fQ,
.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_dashboard__WvJ0H,
.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_cont2__eG76O {
  background-Color: #0f1824;
}

.VendorCustomTable_top_header__GSRr4 .VendorCustomTable_top_header_inner__wC8zl {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.VendorCustomTable_cont2__eG76O {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.VendorCustomTable_subLink__u\\+vsT svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.VendorCustomTable_cst_vendr__lMZbM input {
  min-height: 35px !important;
}

.VendorCustomTable_cst_vendr__lMZbM .VendorCustomTable_form-control__QTMJR {
  background-color: #f5f6fa;
  border: none;
}

.VendorCustomTable_footer__k7VGk {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.VendorCustomTable_bodythemelight__\\+c3yA {
  background-color: #fff;
  padding-top: 90px;
}

.VendorCustomTable_bodythemedark__cxW1h {
  background-color: #132337;
  padding-top: 90px;
}

.VendorCustomTable_bodythemeNew__\\+Qa1T {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.VendorCustomTable_headerthemelight__iEK58 {
  background-color: #fff;
}

.VendorCustomTable_headerthemedark__fpESs {
  background-color: #132337;
}

.VendorCustomTable_top_header__GSRr4 {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.VendorCustomTable_menuthemelight__wT1pQ {
  background-color: #f5f6fa;
}

.VendorCustomTable_menuthemedark__pPYYc {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.VendorCustomTable_menulinklight__26Gu6 span {
  color: #666666 !important;
}

.VendorCustomTable_menulinklight__26Gu6 a {
  color: #CBCBCB !important;
}

.VendorCustomTable_menulinklight__26Gu6:hover span,
.VendorCustomTable_menulinklight__26Gu6:hover a {
  color: #fff !important;
}

.VendorCustomTable_menulinkdarkSelected__yvQkc {
  background-color: #1c2e45;
  color: #3b82f6;
}

.VendorCustomTable_menuthemelight__wT1pQ .VendorCustomTable_menulinklightSelected__r-L44 {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.VendorCustomTable_menulinkdark__oD8xk {
  color: #92afd3 !important;
}

.VendorCustomTable_menulinklight__26Gu6:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.VendorCustomTable_menulinklight__26Gu6 .VendorCustomTable_sub_arrow__ypTdb svg path {
  stroke: #CBCBCB !important;
}

.VendorCustomTable_menulinklight__26Gu6:hover .VendorCustomTable_sub_arrow__ypTdb svg path {
  stroke: #fff !important;
}

.VendorCustomTable_menulinkdark__oD8xk .VendorCustomTable_sub_arrow__ypTdb svg path {
  stroke: #92afd3 !important;
}

.VendorCustomTable_menulinkdark__oD8xk:hover .VendorCustomTable_sub_arrow__ypTdb svg path {
  stroke: #fff !important;
}

.VendorCustomTable_menulinklight__26Gu6:hover svg path,
.VendorCustomTable_menulinklightSelected__r-L44 svg path {
  fill: #fff !important;
}

.VendorCustomTable_menulinkdark__oD8xk:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.VendorCustomTable_headinglight__n8YdT {
  color: #60677e;
}

.VendorCustomTable_headingdark__C2E9c {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.VendorCustomTable_searchboxlight__NuTkq {
  background-color: #fff;
  border: none;
}

.VendorCustomTable_searchboxdark__6RqDl {
  background-color: #132337;
  color: #fff;
  border: none;
}

.VendorCustomTable_searchboxdark__6RqDl::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.VendorCustomTable_tableheadlight__Zmf0s {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.VendorCustomTable_tableheadlight__Zmf0s th {
  color: #fff;
}

thead .VendorCustomTable_tableheadlight__Zmf0s th:first-child,
thead .VendorCustomTable_tableheaddark__jaEbS th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .VendorCustomTable_tableheadlight__Zmf0s th:last-child,
thead .VendorCustomTable_tableheaddark__jaEbS th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.VendorCustomTable_table__EIpax.VendorCustomTable_table-borderless__BlMBL {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.VendorCustomTable_tableheaddark__jaEbS {
  background-color: #132337;
  color: #fff;
}

.VendorCustomTable_table-borderless__BlMBL tr:nth-child(even) {
  background-color: #F9FAFB;
}

.VendorCustomTable_table-borderless__BlMBL .VendorCustomTable_left-section__gVdhE {
  padding-top: 10px;
}

.VendorCustomTable_tablebodylight__SZUxa td,
.VendorCustomTable_tablebodydark__FZiFK td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.VendorCustomTable_tablebodylight__SZUxa {
  background-color: #fff;
}
.VendorCustomTable_tablebodylight__SZUxa:hover {
  background-color: #fff;
  cursor: auto;
}
.VendorCustomTable_tablebodylight__SZUxa p {
  line-height: 24px;
}

.VendorCustomTable_tablebodydark__FZiFK {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.VendorCustomTable_tablebodydark__FZiFK:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.VendorCustomTable_paginationlight__FkOkX {
  color: #60677e !important;
  font-size: 13px !important;
}

.VendorCustomTable_paginationdark__V4JVh {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.VendorCustomTable_formthemelight__22SiP {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.VendorCustomTable_formthemedark__kuRLp {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.VendorCustomTable_formthemedark__kuRLp ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.VendorCustomTable_viewformlight__8l24T {
  background-color: #f3f6f9;
}

.VendorCustomTable_permissionboxlight__HHQ9T {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.VendorCustomTable_permissionboxdark__QOuA7 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.VendorCustomTable_errormsgclr__auQA4 {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.VendorCustomTable_graphclrlight__csp9j {
  background-color: #fff;
}

.VendorCustomTable_graphclrdark__ET6mK {
  background-color: #132337;
}

/* 
Counter theme
*/
#VendorCustomTable_card1bglight__1huoQ {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#VendorCustomTable_card1bgdark__QT5Px {
  background: #392f28;
}

#VendorCustomTable_card2bglight__lClLO {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#VendorCustomTable_card2bgdark__3dzMI {
  background: #1c3238;
}

#VendorCustomTable_card3bglight__IneDI {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#VendorCustomTable_card3bgdark__syKAk {
  background: #3a2434;
}

#VendorCustomTable_card4bglight__IDk83 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#VendorCustomTable_card4bgdark__o9Nz2 {
  background: #2f264f;
}

#VendorCustomTable_card1bgdark__QT5Px a,
#VendorCustomTable_card1bgdark__QT5Px p,
#VendorCustomTable_card2bgdark__3dzMI a,
#VendorCustomTable_card2bgdark__3dzMI p,
#VendorCustomTable_card3bgdark__syKAk a,
#VendorCustomTable_card3bgdark__syKAk p,
#VendorCustomTable_card4bgdark__o9Nz2 a,
#VendorCustomTable_card4bgdark__o9Nz2 p {
  color: #fff;
}

/* 
Action button theme
*/
.VendorCustomTable_actionbtnlight__PwOc7 {
  color: rgba(70, 71, 91, 0.8705882353);
}

.VendorCustomTable_actionbtndark__Jnjae {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.VendorCustomTable_profiledropdownlight__kOO\\+x {
  background-color: #fff;
}

.VendorCustomTable_profiledropdowndark__QSmHv {
  background-color: #151521;
}

.VendorCustomTable_settingsection__nTENS #VendorCustomTable_addform__DQgZ0.VendorCustomTable_formthemedark__kuRLp .VendorCustomTable_savebtn__0U2df {
  background-color: #3b82f6;
  color: #fff;
}

#VendorCustomTable_addform__DQgZ0.VendorCustomTable_formthemedark__kuRLp .VendorCustomTable_savebtn__0U2df {
  background-color: #3b82f6;
  color: #fff;
}

.VendorCustomTable_profile_conatiner__jBgNx {
  border-radius: 5px !important;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_ag-theme-alpine__M-k6S .VendorCustomTable_ag-row__qTyyA {
  background: #000 !important;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_formbtn__S3Qg4 {
  background-color: #3b82f6;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_formbtn__S3Qg4:hover {
  background-color: #2563eb;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_resetbtn__txkw3 {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_resetbtn__txkw3:hover {
  background-color: #3b82f6;
}

.VendorCustomTable_headingdark__C2E9c span {
  background-color: #132337;
}

.VendorCustomTable_resetbtn__txkw3 {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.VendorCustomTable_resetbtn__txkw3:hover,
.VendorCustomTable_resetbtn__txkw3:active,
.VendorCustomTable_resetbtn__txkw3:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.VendorCustomTable_addBtn__vlrJw {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.VendorCustomTable_addDltBtn__2A7wk {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.VendorCustomTable_addbtnlight__9dkiG {
  background-color: #38A169;
}

.VendorCustomTable_addbtndark__DA52\\+ {
  background-color: #3b82f6;
}

.VendorCustomTable_addbtndark__DA52\\+:hover {
  background-color: #2563eb;
}

.VendorCustomTable_formthemedark__kuRLp label {
  color: #92afd3;
}

.VendorCustomTable_addBtn__vlrJw svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.VendorCustomTable_addBtn__vlrJw:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.VendorCustomTable_cust_addBtn__2AAWA.VendorCustomTable_addBtn__vlrJw svg {
  top: 2px;
}

.VendorCustomTable_deleteBtn__v6bzY {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.VendorCustomTable_deleteBtn__v6bzY {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.VendorCustomTable_deleteBtn__v6bzY:active,
.VendorCustomTable_deleteBtn__v6bzY:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.VendorCustomTable_deleteBtn__v6bzY svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.VendorCustomTable_deleteBtn__v6bzY:hover,
.VendorCustomTable_deleteBtn__v6bzY:active,
.VendorCustomTable_deleteBtn__v6bzY:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.VendorCustomTable_confirmBtn__q73VC {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.VendorCustomTable_confirmBtn__q73VC:hover,
.VendorCustomTable_confirmBtn__q73VC:active,
.VendorCustomTable_confirmBtn__q73VC:focus {
  background-color: #0f1824 !important;
}

.VendorCustomTable_confirmBtn__q73VC svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.VendorCustomTable_delPopContainer__qek5f .VendorCustomTable_modal-body__8zOjB {
  padding: 35px;
  text-align: center;
}

.VendorCustomTable_delPopContainer__qek5f .VendorCustomTable_delet_icon__Cho2A {
  margin-bottom: 11px;
}

.VendorCustomTable_delPopContainer__qek5f p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.VendorCustomTable_arrowback__bRP-u svg {
  fill: #000;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_arrowback__bRP-u {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_arrowback__bRP-u svg {
  fill: #3b82f6;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_drpdwn_btn__KtPSN {
  background-color: #132337;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_empname__uayVL {
  color: #92afd3 !important;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_navitemli__EoieM a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_tabnavli__LDjZn a.VendorCustomTable_settingsgeneral__ck3mT,
.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_tabnavli__LDjZn a.VendorCustomTable_settingslinks__QMxxh:hover {
  background-color: #3b82f6;
  color: #fff;
}

.VendorCustomTable_bodythemedark__cxW1h .VendorCustomTable_tabnavli__LDjZn a.VendorCustomTable_settingslinks__QMxxh {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.VendorCustomTable_headerthemedark__fpESs .VendorCustomTable_dropdown_menu_contain__Awmpk {
  background-color: #1c2e45;
  color: #fff;
}

.VendorCustomTable_headerthemedark__fpESs .VendorCustomTable_dropdown_menu_contain__Awmpk ul li a,
.VendorCustomTable_headerthemedark__fpESs .VendorCustomTable_dropdown_menu_contain__Awmpk .VendorCustomTable_dropdown_item__0JcxC,
.VendorCustomTable_headerthemedark__fpESs .VendorCustomTable_dropdown_menu_contain__Awmpk .VendorCustomTable_dropdown_item__0JcxC h5 {
  color: #fff;
}

.VendorCustomTable_headerthemedark__fpESs .VendorCustomTable_dropdown_menu_contain__Awmpk ul li a:hover,
.VendorCustomTable_headerthemedark__fpESs .VendorCustomTable_dropdown_menu_contain__Awmpk .VendorCustomTable_dropdown_item__0JcxC:hover {
  background-color: #132337;
  color: #fff;
}

.VendorCustomTable_dropdown_item__0JcxC:active {
  background-color: #F5F6FA;
}

.VendorCustomTable_profile_arrrow_dwn__9FOoO {
  stroke: #132337;
}

.VendorCustomTable_headerthemedark__fpESs .VendorCustomTable_profile_arrrow_dwn__9FOoO {
  stroke: #fff;
}

.VendorCustomTable_dateinputbox1__X1EeB input,
.VendorCustomTable_dateinputbox1__X1EeB span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.VendorCustomTable_delPopContainer__qek5f .VendorCustomTable_modal-content__z6Zx3 {
  border-radius: 10px;
  min-width: 399px;
}

.VendorCustomTable_larg_model__FWz-x .VendorCustomTable_modal-dialog__2dbBB {
  max-width: 100% !important;
}

.VendorCustomTable_larg_model__FWz-x .VendorCustomTable_modal-content__z6Zx3 {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.VendorCustomTable_larg_model__FWz-x .VendorCustomTable_modal-header__OkZom {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .VendorCustomTable_btn-primary__MmeOP:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.VendorCustomTable_form-select__6da8- {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .VendorCustomTable_CustomTable_tableheadlight__HuHZw__JRACR th:first-child,
thead .VendorCustomTable_CustomTable_tableheaddark__nwqb4__op2bD th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .VendorCustomTable_tableheadlight__Zmf0s th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .VendorCustomTable_dashboard__WvJ0H {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .VendorCustomTable_cont2__eG76O {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .VendorCustomTable_sectionright__SJa5k {
    float: unset !important;
  }
  .VendorCustomTable_dashboard__WvJ0H {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .VendorCustomTable_cont2__eG76O {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .VendorCustomTable_bodythemelight__\\+c3yA,
.VendorCustomTable_bodythemedark__cxW1h {
    padding-top: 110px;
  }
  .VendorCustomTable_delPopContainer__qek5f .VendorCustomTable_modal-content__z6Zx3 {
    min-width: 100%;
  }
  .VendorCustomTable_delPopContainer__qek5f .VendorCustomTable_modal-body__8zOjB {
    padding: 15px;
  }
  .VendorCustomTable_larg_model__FWz-x .VendorCustomTable_modal-content__z6Zx3 {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .VendorCustomTable_exer_modal_contain__8QfeZ .VendorCustomTable_modal-dialog__2dbBB {
    max-width: 1055px;
  }
  .VendorCustomTable_delPopContainer__qek5f .VendorCustomTable_modal-dialog__2dbBB {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.VendorCustomTable_active_show_outer__Zy1xh h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .VendorCustomTable_active_show_outer__Zy1xh h2 {
    margin-top: 15px;
  }
}
.VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 {
  width: 100%;
  display: block;
}
.VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 .VendorCustomTable_act_box_img__kRhtX {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 .VendorCustomTable_act_box_img__kRhtX {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 .VendorCustomTable_act_box_img__kRhtX img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 .VendorCustomTable_act_box_cnt__qV-3l {
  width: 100%;
  display: block;
}
.VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 .VendorCustomTable_act_box_cnt__qV-3l svg {
  flex-shrink: 0;
}
.VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 .VendorCustomTable_act_box_cnt__qV-3l .VendorCustomTable_act_box_bdg__LpVYN {
  width: 100%;
  margin-bottom: 12px;
}
.VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 .VendorCustomTable_act_box_cnt__qV-3l .VendorCustomTable_act_box_bdg__LpVYN span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 .VendorCustomTable_act_box_cnt__qV-3l .VendorCustomTable_act_box_bdg__LpVYN .VendorCustomTable_sold__S1AmV {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 .VendorCustomTable_act_box_cnt__qV-3l h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 .VendorCustomTable_act_box_cnt__qV-3l p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 .VendorCustomTable_act_box_cnt__qV-3l p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.VendorCustomTable_active_show_outer__Zy1xh .VendorCustomTable_active_show_inner__tHFC9 .VendorCustomTable_act_box_cnt__qV-3l p .VendorCustomTable_timezone_code_pill__2aTzq {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#VendorCustomTable_attent_details_row1__t-yzN {
  margin-bottom: 0 !important;
}

.VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_l__tmH8l img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_r__zfwDp {
  flex: 1 1;
}
.VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_r__zfwDp .VendorCustomTable_attent_details_row__5b465 {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_r__zfwDp .VendorCustomTable_attent_details_row__5b465 {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_r__zfwDp .VendorCustomTable_attent_details_row__5b465 .VendorCustomTable_attent_details_row_box__E1mKl {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_r__zfwDp .VendorCustomTable_attent_details_row__5b465 .VendorCustomTable_attent_details_row_box__E1mKl {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_r__zfwDp .VendorCustomTable_attent_details_row__5b465 .VendorCustomTable_attent_details_row_box__E1mKl {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_r__zfwDp .VendorCustomTable_attent_details_row__5b465 .VendorCustomTable_attent_details_row_box__E1mKl p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_r__zfwDp .VendorCustomTable_attent_details_row__5b465 .VendorCustomTable_attent_details_row_box__E1mKl h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_r__zfwDp .VendorCustomTable_attent_details_row_last__mvVRS {
  margin-bottom: 0px !important;
}
.VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_r__zfwDp .VendorCustomTable_attent_details_row_last__mvVRS.VendorCustomTable_interesting_fact__sTh-S {
  padding-top: 30px;
}
.VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_r__zfwDp .VendorCustomTable_attent_details_row_last__mvVRS.VendorCustomTable_interesting_fact__sTh-S .VendorCustomTable_attent_details_row_box__E1mKl {
  width: 100%;
}
.VendorCustomTable_attent_details__oID1m .VendorCustomTable_attent_details_inner__29QhS .VendorCustomTable_attent_details_inner_r__zfwDp .VendorCustomTable_attent_details_row_last__mvVRS.VendorCustomTable_interesting_fact__sTh-S .VendorCustomTable_attent_details_row_box__E1mKl h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.VendorCustomTable_showbox_sec__qduri {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .VendorCustomTable_showbox_sec__qduri {
    justify-content: center;
  }
}

.VendorCustomTable_show_box_main__bs2UK {
  margin: 10px 0px;
}
.VendorCustomTable_show_box_main__bs2UK .VendorCustomTable_show_box__waNd6 {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .VendorCustomTable_show_box_main__bs2UK .VendorCustomTable_show_box__waNd6 {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .VendorCustomTable_show_box_main__bs2UK .VendorCustomTable_show_box__waNd6 {
    min-height: 500px;
    width: 200px !important;
  }
}
.VendorCustomTable_show_box_main__bs2UK .VendorCustomTable_show_box__waNd6 img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .VendorCustomTable_show_box_main__bs2UK .VendorCustomTable_show_box__waNd6 img {
    max-height: 300px !important;
  }
}
.VendorCustomTable_show_box_main__bs2UK .VendorCustomTable_show_box__waNd6:last-child {
  margin-right: 0px !important;
}
.VendorCustomTable_show_box_main__bs2UK .VendorCustomTable_no_show_box__9ZLmt {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .VendorCustomTable_show_box_main__bs2UK .VendorCustomTable_no_show_box__9ZLmt {
    width: 250px !important;
  }
}
.VendorCustomTable_show_box_main__bs2UK .VendorCustomTable_no_show_box__9ZLmt img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .VendorCustomTable_show_box_main__bs2UK .VendorCustomTable_no_show_box__9ZLmt img {
    max-height: 350px !important;
  }
}
.VendorCustomTable_show_box_main__bs2UK .VendorCustomTable_no_show_box__9ZLmt h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .VendorCustomTable_show_box_main__bs2UK .VendorCustomTable_no_show_box__9ZLmt h6 {
    font-size: 20px;
  }
}

.VendorCustomTable_attent_flex__VPuqj {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.VendorCustomTable_attent_flex__VPuqj h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

#VendorCustomTable_container__uAajP {
  padding: 0px;
}

#VendorCustomTable_tableheading__GFWj4 {
  font-size: 16px;
  margin-top: 20px;
}

.VendorCustomTable_search_box__Cf0Lu {
  position: relative;
}

thead .VendorCustomTable_CustomTable_tableheadlight__HuHZw__JRACR th:first-child, thead .VendorCustomTable_CustomTable_tableheaddark__nwqb4__op2bD th:first-child {
  display: math !important;
}

#VendorCustomTable_spinner__sFkPi {
  float: right;
  margin-top: -25px;
  position: relative;
  z-index: 1;
  margin-right: 10px;
  cursor: pointer;
  color: #131F43;
}

.VendorCustomTable_tbl_sl__m0zT2 {
  min-width: 10px !important;
}

/* Same typography as PageLoader — regular weight */
.VendorCustomTable_tableLoadingCell__HT3KQ {
  text-align: center;
  padding: 48px 16px !important;
  vertical-align: middle;
}

.VendorCustomTable_tableLoadingText__T3IHw {
  font-family: "Lufga", "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #736b66;
  margin: 0;
}

.VendorCustomTable_tablebtn__C9pMf {
  width: 70px;
  padding: 6px;
  border: none;
  background-color: #131F43;
  border-radius: 5px;
  color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14px;
}
.VendorCustomTable_tablebtn__C9pMf:hover {
  background-color: rgba(37, 105, 109, 0.864);
}

table {
  border-collapse: separate !important;
  border-spacing: 0 6px !important;
}

td:first-child,
th:first-child {
  border-radius: 8px 0 0 8px;
}

td:last-child,
th:last-child {
  border-radius: 0 8px 8px 0;
}

.VendorCustomTable_tableheaddiv__1k9Bs {
  display: flex;
}

th, td {
  font-size: 14px;
}

th {
  padding: 0.8rem 1rem !important;
}

td {
  padding: 0.5rem 1rem !important;
  line-height: 28px;
}

.VendorCustomTable_sortbtn__RX3kH {
  border: none;
  background: none;
  color: #6E6E6E;
}

.VendorCustomTable_order_date__fNhbV {
  margin-top: 5px;
  font-size: 12px;
  color: #000;
  font-weight: normal;
}

h6 {
  color: #000;
}

.VendorCustomTable_norecord__-ucoV {
  font-size: 22px;
  margin-top: 10px;
  color: #939090;
}

.VendorCustomTable_norecordsdiv__MrxT3 {
  position: absolute;
  left: 42%;
  margin-top: 2%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.VendorCustomTable_sectionright__SJa5k {
  float: right;
  display: flex;
  gap: 30px;
}
.VendorCustomTable_sectionright__SJa5k #VendorCustomTable_dropdown__8mmTe {
  margin: 0px 10px 10px 10px;
}
.VendorCustomTable_sectionright__SJa5k #VendorCustomTable_dropdown__8mmTe button {
  background-color: #131F43;
  border-radius: 5px;
  border: none;
  box-shadow: none;
  font-size: 14px;
  min-width: 140px;
  min-height: 44px;
}
.VendorCustomTable_sectionright__SJa5k a {
  font-size: 14px;
}
.VendorCustomTable_sectionright__SJa5k #VendorCustomTable_del_icon__BbRWH {
  font-size: 12px;
  margin-left: 5px;
}

.VendorCustomTable_tdactive__\\+C3Hm {
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  margin-top: 8px;
  background: rgba(0, 193, 107, 0.2);
  color: #00C16B;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin-top: 8px;
}

.VendorCustomTable_tdinactive__lG\\+tg {
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: rgba(255, 0, 0, 0.2);
  color: #F00;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin-top: 8px;
}

.VendorCustomTable_tdyellowbg__iU1Cp {
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: rgba(253, 152, 0, 0.2);
  color: #FD9800;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin-top: 8px;
}

@media only screen and (max-width: 600px) {
  #VendorCustomTable_dashboardcont2__\\+tK8K {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
  .VendorCustomTable_sectionright__SJa5k {
    gap: 0;
    flex-direction: column;
  }
}
tr:nth-child(even) {
  background-color: #fcfcfc;
}`, "",{"version":3,"sources":["webpack://./src/components/VendorCustomTable/VendorCustomTable.module.scss","webpack://./src/styles/Variables/Variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ADtEF;;ACyEA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ADtEF;;ACyEA;;;EAGE,yBApEoB;ADFtB;;ACyEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ADtEF;;ACyEA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ADpEF;;AC0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ADvEF;;AC4EA;EACE,2BAAA;ADzEF;;AC4EA;EACE,yBAAA;EACA,YAAA;ADzEF;;AC6EA;EACE,YAAA;AD1EF;;AC6EA;EACE,sBA9GY;ADoCd;;AC6EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AD1EF;;AC6EA;EACE,yBArIgB;EAsIhB,iBAAA;AD1EF;;AC6EA;EACE,yBAAA;AD1EF;;AC6EA;;CAAA;AAGA;EACE,sBAtIY;AD4Dd;;AC6EA;EACE,yBArJgB;AD2ElB;;AC6EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AD1EF;;AC6EA;;CAAA;AAGA;EACE,yBAAA;AD1EF;;AC6EA;EACE,yBA1KgB;ADgGlB;;AC6EA;;CAAA;AAGA;EACE,yBAAA;AD1EF;;AC6EA;EACE,yBAAA;AD1EF;;AC6EA;;EAEE,sBAAA;AD1EF;;AC6EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AD6HpB;;AC6EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AD1EF;;AC6EA;EACE,yBAAA;AD1EF;;AC6EA;EACE,sBAAA;EACA,oCAAA;AD1EF;;AC6EA;EACE,0BAAA;AD1EF;;AC6EA;EACE,uBAAA;AD1EF;;AC6EA;EACE,0BAAA;AD1EF;;AC6EA;EACE,uBAAA;AD1EF;;AC6EA;;EAEE,qBAAA;AD1EF;;AC6EA;EACE,yBArOsB;EAsOtB,WA7NY;ADmJd;;AC6EA;;CAAA;AAGA;EACE,cAjOe;ADuJjB;;AC6EA;EACE,cArOe;AD2JjB;;AC6EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AD1EF;;AC6EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AD1EF;;AC6EA;EACE,cAvPe;AD6KjB;;AC6EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AD1EF;;AC6EA;EACE,WAtQY;AD4Ld;;AC6EA;;EAEE,0BAAA;AD1EF;;AC6EA;;EAEE,0BAAA;AD1EF;;AC6EA;EACE,kBAAA;AD1EF;;AC6EA;EACE,kBAAA;AD1EF;;AC6EA;EACE,oCAAA;EACA,gCAAA;AD1EF;;AC6EA;EACE,yBAzRkB;EA0RlB,WAlSY;ADwNd;;AC6EA;EACE,yBAAA;AD1EF;;AC6EA;EACE,iBAAA;AD1EF;;AC6EA;;EAEE,+BAAA;EACA,iBAAA;AD1EF;;AC6EA;EACE,sBApTY;AD0Od;AC4EE;EACE,sBAvTU;EAwTV,YAAA;AD1EJ;AC4EE;EACA,iBAAA;AD1EF;;AC+EA;EACE,0CAAA;EACA,cA/Te;ADmPjB;AC8EE;EACE,yCAAA;EACA,eAAA;AD5EJ;;ACgFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AD7EF;;ACgFA;EACE,yBAAA;EACA,0BAAA;AD7EF;;ACgFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AD7EF;;ACgFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AD7EF;AC+EE;EACE,cAnWa;ADsRjB;;ACkFA;;CAAA;AAGA;EACE,yBAlXgB;ADmSlB;;ACkFA;EACE,yBAAA;EACA,yBAAA;AD/EF;;ACkFA;EACE,yBAlYoB;EAmYpB,yBAAA;AD/EF;;ACkFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AD/EF;;ACkFA;;CAAA;AAGA;EACE,sBAtYY;ADuTd;;ACkFA;EACE,yBAlYkB;ADmTpB;;ACmFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ADmUd;;ACmFA;EACE,mBAAA;ADhFF;;ACmFA;EACE,gGAAA;EACA,sBA5ZY;AD4Ud;;ACmFA;EACE,mBAAA;ADhFF;;ACmFA;EACE,gGAAA;EACA,sBAraY;ADqVd;;ACmFA;EACE,mBAAA;ADhFF;;ACmFA;EACE,gGAAA;EACA,sBA9aY;AD8Vd;;ACmFA;EACE,mBAAA;ADhFF;;ACmFA;;;;;;;;EAQE,WA7bY;AD6Wd;;ACmFA;;CAAA;AAGA;EACE,qCAAA;ADhFF;;ACmFA;EACE,cArce;ADqXjB;;ACoFA;;CAAA;AAGA;EACE,sBAAA;ADjFF;;ACoFA;EACE,yBAAA;ADjFF;;ACoFA;EACE,yBAzekB;EA0elB,WAzdY;ADwYd;;ACoFA;EACE,yBA9ekB;EA+elB,WA9dY;AD6Yd;;ACoFA;EACE,6BAAA;ADjFF;;ACoFA;EACE,2BAAA;ADjFF;;ACoFA;EACE,yBA3fkB;AD0apB;;ACoFA;EACE,yBA9fwB;AD6a1B;;ACoFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;ADjFF;;ACoFA;EACE,yBAzgBkB;ADwbpB;;ACqFA;EACE,yBAxgBgB;ADsblB;;ACqFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ADlFF;;ACqFA;;;EAGE,oCAAA;EACA,sBAAA;ADlFF;;ACqFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ADyfhB;;ACqFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ADmgBhB;;ACqFA;EACE,yBAjkBY;AD+ed;;ACqFA;EACE,yBA3jBkB;ADyepB;;ACqFA;EACE,yBA9jBwB;AD4e1B;;ACqFA;EACE,cApkBiB;ADkfnB;;ACsFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ADnFF;;ACsFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ADnFF;;ACsFA;EACE,QAAA;ADnFF;;ACsFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ADnFF;;ACsFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ADnFF;;ACsFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ADnFF;;ACsFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ADnFF;;ACsFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ADnFF;;ACsFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ADnFF;;ACsFA;;;EAGE,oCAAA;ADnFF;;ACsFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ADnFF;;ACwFA;EACE,aAAA;EACA,kBAAA;ADrFF;;ACwFA;EACE,mBAAA;ADrFF;;ACwFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ADrFF;;ACwFA;EACE,UAAA;ADrFF;;ACwFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AD2lBpB;;ACwFA;EACE,aAprBkB;AD+lBpB;;ACwFA;EACE,yBAhrBgB;AD2lBlB;;ACwFA;EACE,yBAAA;ADrFF;;ACwFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;AD0lBd;;ACwFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;ADgmBd;;ACwFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ADsmBd;;ACwFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AD2mBd;;ACwFA;;;EAGE,WAtsBY;ADinBd;;ACwFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ADunBd;;ACwFA;EACE,yBA9vBO;ADyqBT;;ACwFA;EACE,eA/tBgB;AD0oBlB;;ACwFA;EACE,YAxtBY;ADmoBd;;ACwFA;;EAEE,sBAAA;ADrFF;;ACwFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;ADzFF;;AC4FA;EACE,0BAAA;ADzFF;;AC4FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;ADzFF;;AC4FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;ADzFF;;AC4FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;ADzFF;;AC4FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;ADzFF;;AC4FA;;EAEE,0BAAA;EACA,aAAA;ADzFF;;AC4FA;EACE,kBAAA;EACA,kBAAA;ADzFF;;AC4FA;EACE;IACE,gBAAA;EDzFF;AACF;AC4FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ED1FF;EC6FA;IACE,uBAAA;IACA,+BAAA;ED3FF;AACF;AC8FA;EACE;;IAAA;AD1FF;AC+FA;EACE;IACE,uBAAA;ED7FF;ECgGA;IACE,6BAAA;ED9FF;AACF;ACiGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;ED/FF;ECkGA;;IAEE,kBAAA;EDhGF;ECmGA;IACE,eAAA;EDjGF;ECoGA;IACE,aAAA;EDlGF;ECqGA;IACE,8BAAA;IACA,aAAA;EDnGF;AACF;ACsGA;EACE;IACE,iBAAA;EDpGF;ECuGA;IACE,gBAAA;EDrGF;ECwGA;;KAAA;ADpGF;ACyGA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADzGJ;AC0GI;EAPF;IAQI,gBAAA;EDvGJ;AACF;AC0GE;EACE,WAAA;EACA,cAAA;ADxGJ;AC0GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ADxGN;ACyGM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;EDtGN;AACF;ACuGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ADrGR;ACyGI;EACE,WAAA;EACA,cAAA;ADvGN;ACwGA;EACE,cAAA;ADtGF;ACwGM;EACE,WAAA;EACA,mBAAA;ADtGR;ACwGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ADtGV;ACyGQ;EACE,kFAAA;ADvGV;AC4GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AD1GR;AC6GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AD3GR;AC6GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AD3GV;AC8GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AD5GV;;ACmHA,mBAAA;AACA;EACI,2BAAA;ADhHJ;;ACmHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ADhHJ;ACkHI;EATF;IAUI,yBAAA;ED/GJ;AACF;ACiHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;ED9GJ;AACF;ACiHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AD/GR;ACmHI;EACE,SAAA;ADjHN;ACmHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ADjHR;ACmHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;EDhHR;AACF;ACkHQ;EACE,SAAA;EACA,UAAA;ADhHV;ACkHU;EAJF;IAKI,gCAAA;IACA,sBAAA;ED/GV;AACF;ACiHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;ED9GV;AACF;ACgHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AD9GZ;ACiHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AD/GZ;ACoHM;EACE,6BAAA;ADlHR;ACmHQ;EACE,iBAAA;ADjHV;ACkHU;EACE,WAAA;ADhHZ;ACiHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AD/Gd;;ACwHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ADrHJ;ACsHI;EANH;IAOK,uBAAA;EDnHJ;AACF;;ACqHA;EACE,gBAAA;ADlHF;ACoHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ADlHJ;ACoHI;EARF;IASI,kBAAA;EDjHJ;AACF;ACkHI;EAXF;IAYI,iBAAA;IACA,uBAAA;ED/GJ;AACF;ACiHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AD/GN;ACiHM;EALF;IAMI,4BAAA;ED9GN;AACF;ACiHI;EACE,4BAAA;AD/GN;ACmHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;ADjHJ;ACmHI;EALF;IAMI,uBAAA;EDhHJ;AACF;ACkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ADhHN;ACkHM;EALF;IAMI,4BAAA;ED/GN;AACF;ACiHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AD/GN;ACgHM;EARF;IASI,eAAA;ED7GN;AACF;;ACoHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;ADjHF;ACmHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;ADjHJ;;AA1lCA;EACE,YAAA;AA6lCF;;AA1lCA;EACI,eAAA;EACA,gBAAA;AA6lCJ;;AA1lCA;EACE,kBAAA;AA6lCF;;AA1lCA;EACE,wBAAA;AA6lCF;;AA1lCA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,cC0CiB;ADmjCnB;;AA1lCA;EACE,0BAAA;AA6lCF;;AA1lCA,mDAAA;AACA;EACE,kBAAA;EACA,6BAAA;EACA,sBAAA;AA6lCF;;AA1lCA;EACE,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA6lCF;;AA1lCA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBCgBe;EDff,kBAAA;EACA,WCCU;EDAV,gBAAA;EACA,mBAAA;EACA,eAAA;AA6lCJ;AA3lCI;EACE,2CCSe;ADolCrB;;AAzlCA;EACI,oCAAA;EACA,gCAAA;AA4lCJ;;AAxlCA;;EAEI,0BAAA;AA2lCJ;;AAvlCA;;EAEI,0BAAA;AA0lCJ;;AAvlCA;EACE,aAAA;AA0lCF;;AAxlCE;EACE,eAAA;AA2lCJ;;AAtlCE;EACE,+BAAA;AAylCJ;;AAtlCE;EACE,+BAAA;EACA,iBAAA;AAylCJ;;AA7kCA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;AAglCF;;AA7kCA;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAglCJ;;AA7kCA;EACE,WAAA;AAglCF;;AA5kCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA+kCJ;;AA7kCE;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAglCJ;;AA5kCA;EACE,YAAA;EACA,aAAA;EACA,SAAA;AA+kCF;AA7kCE;EACE,0BAAA;AA+kCJ;AA7kCE;EACI,yBClFa;EDmFb,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA+kCN;AA7kCE;EACI,eAAA;AA+kCN;AA5kCE;EACE,eAAA;EACA,gBAAA;AA8kCJ;;AA1kCA;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA6kCF;;AAzkCA;EACE,iBAAA;EACF,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA4kCA;;AAzkCA;EACE,iBAAA;EACF,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA4kCA;;AAtkCA;EACE;IACI,wBC1IM;ID2IN,UC1IK;ID2IL,kBAAA;IACA,aClJa;ED2tCjB;EAvkCA;IACE,MAAA;IACA,sBAAA;EAykCF;AACF;AAvkCC;EACC,yBAAA;AAykCF","sourcesContent":["@import \"/src/styles/Variables/Variables.scss\";\n\n\n#container{\n  padding: 0px;\n}\n\n#tableheading{\n    font-size: 16px;\n    margin-top: 20px;\n  }\n\n.search_box{\n  position: relative;\n}\n \nthead .CustomTable_tableheadlight__HuHZw th:first-child, thead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  display: math !important;\n}\n\n#spinner{\n  float: right;\n  margin-top: -25px;\n  position: relative;\n  z-index: 1;\n  margin-right: 10px;\n  cursor: pointer;\n  color: $primary-btncolor;\n}\n\n.tbl_sl {\n  min-width: 10px !important;\n}\n\n/* Same typography as PageLoader — regular weight */\n.tableLoadingCell {\n  text-align: center;\n  padding: 48px 16px !important;\n  vertical-align: middle;\n}\n\n.tableLoadingText {\n  font-family: 'Lufga', 'Inter', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: #736b66;\n  margin: 0;\n}\n\n.tablebtn{\n    width: 70px;\n    padding: 6px;\n    border:  none;\n    background-color: $primary-btncolor;\n    border-radius: 5px;\n    color: $white-color;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-size: 14px;\n\n    &:hover{\n      background-color: $secondary-btncolor;\n    }\n  }\n\ntable{\n    border-collapse:separate !important;\n    border-spacing:0 6px !important;\n  }\n\n// Set border-radius on the top-left and bottom-left of the first table data on the table row\ntd:first-child,\nth:first-child {\n    border-radius: 8px 0 0 8px;\n  }\n\n// Set border-radius on the top-right and bottom-right of the last table data on the table row\ntd:last-child,\nth:last-child {\n    border-radius: 0 8px 8px 0;\n  }\n  \n.tableheaddiv{\n  display: flex;\n}\n  th,td{\n    font-size: 14px;\n     \n     \n  }\n\n  th{\n    padding: 0.8rem 1rem !important;\n  }\n\n  td{\n    padding: .5rem 1rem !important;\n    line-height: 28px;\n  }\n\n\n\n// .order_date{\n//     margin-top: 5px;\n//     font-size: 12px;\n//     color: #898989;\n//     font-weight: normal;\n//   }\n\n.sortbtn{\n  border: none;\n  background: none;\n  color: #6E6E6E;\n  }\n\n.order_date{\n    margin-top: 5px;\n    font-size: 12px;\n    color:#000;\n    font-weight: normal;\n  }\n\nh6{\n  color: #000;\n  }\n\n  \n  .norecord {\n    font-size: 22px;\n    margin-top: 10px;\n    color: #939090;\n  }\n  .norecordsdiv{\n    position: absolute;\n    left: 42%;\n    margin-top: 2%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n\n.sectionright{\n  float: right;\n  display: flex;\n  gap: 30px;\n\n  #dropdown{\n    margin:0px 10px 10px 10px;\n  }\n  #dropdown button{\n      background-color:$primary-btncolor;\n      border-radius:5px;\n      border:none;\n      box-shadow:none;\n      font-size:14px;\n      min-width: 140px;\n      min-height: 44px;\n  }\n  a{\n      font-size:14px;\n       \n  }\n  #del_icon{\n    font-size: 12px;\n    margin-left:5px;\n}\n\n}\n.tdactive{\n  padding: 8px 10px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100px;\n  margin-top: 8px;\n  background: rgba(0, 193, 107, 0.20);\n  color: #00C16B;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-transform: uppercase;\n  margin-top: 8px;\n\n}\n\n.tdinactive{\n  padding: 8px 10px;\njustify-content: center;\nalign-items: center;\nborder-radius: 100px;\nbackground: rgba(255, 0, 0, 0.20);\ncolor: #F00;\ntext-align: center;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\ntext-transform: uppercase;\nmargin-top: 8px;\n}\n\n.tdyellowbg{\n  padding: 8px 10px;\njustify-content: center;\nalign-items: center;\nborder-radius: 100px;\nbackground: rgba(253, 152, 0, 0.20);\ncolor: #FD9800;\ntext-align: center;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\ntext-transform: uppercase;\nmargin-top: 8px;\n}\n\n\n\n\n@media only screen and (max-width: 600px) {\n  #dashboardcont2{\n      width: $dashwidth;\n      left: $dashleft;\n      position: relative;\n      padding: $dashboardpadding;\n  }\n  .sectionright {\n    gap: 0;\n    flex-direction: column;\n  }\n}\n tr:nth-child(even){\n  background-color: #fcfcfc;\n} \n\n\n","/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `VendorCustomTable_dashboard__WvJ0H`,
	"dashboardContain": `VendorCustomTable_dashboardContain__153fQ`,
	"bodythemedark": `VendorCustomTable_bodythemedark__cxW1h`,
	"cont2": `VendorCustomTable_cont2__eG76O`,
	"top_header": `VendorCustomTable_top_header__GSRr4`,
	"top_header_inner": `VendorCustomTable_top_header_inner__wC8zl`,
	"subLink": `VendorCustomTable_subLink__u+vsT`,
	"cst_vendr": `VendorCustomTable_cst_vendr__lMZbM`,
	"form-control": `VendorCustomTable_form-control__QTMJR`,
	"footer": `VendorCustomTable_footer__k7VGk`,
	"bodythemelight": `VendorCustomTable_bodythemelight__+c3yA`,
	"bodythemeNew": `VendorCustomTable_bodythemeNew__+Qa1T`,
	"headerthemelight": `VendorCustomTable_headerthemelight__iEK58`,
	"headerthemedark": `VendorCustomTable_headerthemedark__fpESs`,
	"menuthemelight": `VendorCustomTable_menuthemelight__wT1pQ`,
	"menuthemedark": `VendorCustomTable_menuthemedark__pPYYc`,
	"menulinklight": `VendorCustomTable_menulinklight__26Gu6`,
	"menulinkdarkSelected": `VendorCustomTable_menulinkdarkSelected__yvQkc`,
	"menulinklightSelected": `VendorCustomTable_menulinklightSelected__r-L44`,
	"menulinkdark": `VendorCustomTable_menulinkdark__oD8xk`,
	"sub_arrow": `VendorCustomTable_sub_arrow__ypTdb`,
	"headinglight": `VendorCustomTable_headinglight__n8YdT`,
	"headingdark": `VendorCustomTable_headingdark__C2E9c`,
	"searchboxlight": `VendorCustomTable_searchboxlight__NuTkq`,
	"searchboxdark": `VendorCustomTable_searchboxdark__6RqDl`,
	"tableheadlight": `VendorCustomTable_tableheadlight__Zmf0s`,
	"tableheaddark": `VendorCustomTable_tableheaddark__jaEbS`,
	"table": `VendorCustomTable_table__EIpax`,
	"table-borderless": `VendorCustomTable_table-borderless__BlMBL`,
	"left-section": `VendorCustomTable_left-section__gVdhE`,
	"tablebodylight": `VendorCustomTable_tablebodylight__SZUxa`,
	"tablebodydark": `VendorCustomTable_tablebodydark__FZiFK`,
	"paginationlight": `VendorCustomTable_paginationlight__FkOkX`,
	"paginationdark": `VendorCustomTable_paginationdark__V4JVh`,
	"formthemelight": `VendorCustomTable_formthemelight__22SiP`,
	"formthemedark": `VendorCustomTable_formthemedark__kuRLp`,
	"viewformlight": `VendorCustomTable_viewformlight__8l24T`,
	"permissionboxlight": `VendorCustomTable_permissionboxlight__HHQ9T`,
	"permissionboxdark": `VendorCustomTable_permissionboxdark__QOuA7`,
	"errormsgclr": `VendorCustomTable_errormsgclr__auQA4`,
	"graphclrlight": `VendorCustomTable_graphclrlight__csp9j`,
	"graphclrdark": `VendorCustomTable_graphclrdark__ET6mK`,
	"card1bglight": `VendorCustomTable_card1bglight__1huoQ`,
	"card1bgdark": `VendorCustomTable_card1bgdark__QT5Px`,
	"card2bglight": `VendorCustomTable_card2bglight__lClLO`,
	"card2bgdark": `VendorCustomTable_card2bgdark__3dzMI`,
	"card3bglight": `VendorCustomTable_card3bglight__IneDI`,
	"card3bgdark": `VendorCustomTable_card3bgdark__syKAk`,
	"card4bglight": `VendorCustomTable_card4bglight__IDk83`,
	"card4bgdark": `VendorCustomTable_card4bgdark__o9Nz2`,
	"actionbtnlight": `VendorCustomTable_actionbtnlight__PwOc7`,
	"actionbtndark": `VendorCustomTable_actionbtndark__Jnjae`,
	"profiledropdownlight": `VendorCustomTable_profiledropdownlight__kOO+x`,
	"profiledropdowndark": `VendorCustomTable_profiledropdowndark__QSmHv`,
	"settingsection": `VendorCustomTable_settingsection__nTENS`,
	"addform": `VendorCustomTable_addform__DQgZ0`,
	"savebtn": `VendorCustomTable_savebtn__0U2df`,
	"profile_conatiner": `VendorCustomTable_profile_conatiner__jBgNx`,
	"ag-theme-alpine": `VendorCustomTable_ag-theme-alpine__M-k6S`,
	"ag-row": `VendorCustomTable_ag-row__qTyyA`,
	"formbtn": `VendorCustomTable_formbtn__S3Qg4`,
	"resetbtn": `VendorCustomTable_resetbtn__txkw3`,
	"addBtn": `VendorCustomTable_addBtn__vlrJw`,
	"addDltBtn": `VendorCustomTable_addDltBtn__2A7wk`,
	"addbtnlight": `VendorCustomTable_addbtnlight__9dkiG`,
	"addbtndark": `VendorCustomTable_addbtndark__DA52+`,
	"cust_addBtn": `VendorCustomTable_cust_addBtn__2AAWA`,
	"deleteBtn": `VendorCustomTable_deleteBtn__v6bzY`,
	"confirmBtn": `VendorCustomTable_confirmBtn__q73VC`,
	"delPopContainer": `VendorCustomTable_delPopContainer__qek5f`,
	"modal-body": `VendorCustomTable_modal-body__8zOjB`,
	"delet_icon": `VendorCustomTable_delet_icon__Cho2A`,
	"arrowback": `VendorCustomTable_arrowback__bRP-u`,
	"drpdwn_btn": `VendorCustomTable_drpdwn_btn__KtPSN`,
	"empname": `VendorCustomTable_empname__uayVL`,
	"navitemli": `VendorCustomTable_navitemli__EoieM`,
	"tabnavli": `VendorCustomTable_tabnavli__LDjZn`,
	"settingsgeneral": `VendorCustomTable_settingsgeneral__ck3mT`,
	"settingslinks": `VendorCustomTable_settingslinks__QMxxh`,
	"dropdown_menu_contain": `VendorCustomTable_dropdown_menu_contain__Awmpk`,
	"dropdown_item": `VendorCustomTable_dropdown_item__0JcxC`,
	"profile_arrrow_dwn": `VendorCustomTable_profile_arrrow_dwn__9FOoO`,
	"dateinputbox1": `VendorCustomTable_dateinputbox1__X1EeB`,
	"modal-content": `VendorCustomTable_modal-content__z6Zx3`,
	"larg_model": `VendorCustomTable_larg_model__FWz-x`,
	"modal-dialog": `VendorCustomTable_modal-dialog__2dbBB`,
	"modal-header": `VendorCustomTable_modal-header__OkZom`,
	"btn-primary": `VendorCustomTable_btn-primary__MmeOP`,
	"form-select": `VendorCustomTable_form-select__6da8-`,
	"CustomTable_tableheadlight__HuHZw": `VendorCustomTable_CustomTable_tableheadlight__HuHZw__JRACR`,
	"CustomTable_tableheaddark__nwqb4": `VendorCustomTable_CustomTable_tableheaddark__nwqb4__op2bD`,
	"sectionright": `VendorCustomTable_sectionright__SJa5k`,
	"exer_modal_contain": `VendorCustomTable_exer_modal_contain__8QfeZ`,
	"active_show_outer": `VendorCustomTable_active_show_outer__Zy1xh`,
	"active_show_inner": `VendorCustomTable_active_show_inner__tHFC9`,
	"act_box_img": `VendorCustomTable_act_box_img__kRhtX`,
	"act_box_cnt": `VendorCustomTable_act_box_cnt__qV-3l`,
	"act_box_bdg": `VendorCustomTable_act_box_bdg__LpVYN`,
	"sold": `VendorCustomTable_sold__S1AmV`,
	"timezone_code_pill": `VendorCustomTable_timezone_code_pill__2aTzq`,
	"attent_details_row1": `VendorCustomTable_attent_details_row1__t-yzN`,
	"attent_details": `VendorCustomTable_attent_details__oID1m`,
	"attent_details_inner": `VendorCustomTable_attent_details_inner__29QhS`,
	"attent_details_inner_l": `VendorCustomTable_attent_details_inner_l__tmH8l`,
	"attent_details_inner_r": `VendorCustomTable_attent_details_inner_r__zfwDp`,
	"attent_details_row": `VendorCustomTable_attent_details_row__5b465`,
	"attent_details_row_box": `VendorCustomTable_attent_details_row_box__E1mKl`,
	"attent_details_row_last": `VendorCustomTable_attent_details_row_last__mvVRS`,
	"interesting_fact": `VendorCustomTable_interesting_fact__sTh-S`,
	"showbox_sec": `VendorCustomTable_showbox_sec__qduri`,
	"show_box_main": `VendorCustomTable_show_box_main__bs2UK`,
	"show_box": `VendorCustomTable_show_box__waNd6`,
	"no_show_box": `VendorCustomTable_no_show_box__9ZLmt`,
	"attent_flex": `VendorCustomTable_attent_flex__VPuqj`,
	"container": `VendorCustomTable_container__uAajP`,
	"tableheading": `VendorCustomTable_tableheading__GFWj4`,
	"search_box": `VendorCustomTable_search_box__Cf0Lu`,
	"spinner": `VendorCustomTable_spinner__sFkPi`,
	"tbl_sl": `VendorCustomTable_tbl_sl__m0zT2`,
	"tableLoadingCell": `VendorCustomTable_tableLoadingCell__HT3KQ`,
	"tableLoadingText": `VendorCustomTable_tableLoadingText__T3IHw`,
	"tablebtn": `VendorCustomTable_tablebtn__C9pMf`,
	"tableheaddiv": `VendorCustomTable_tableheaddiv__1k9Bs`,
	"sortbtn": `VendorCustomTable_sortbtn__RX3kH`,
	"order_date": `VendorCustomTable_order_date__fNhbV`,
	"norecord": `VendorCustomTable_norecord__-ucoV`,
	"norecordsdiv": `VendorCustomTable_norecordsdiv__MrxT3`,
	"dropdown": `VendorCustomTable_dropdown__8mmTe`,
	"del_icon": `VendorCustomTable_del_icon__BbRWH`,
	"tdactive": `VendorCustomTable_tdactive__+C3Hm`,
	"tdinactive": `VendorCustomTable_tdinactive__lG+tg`,
	"tdyellowbg": `VendorCustomTable_tdyellowbg__iU1Cp`,
	"dashboardcont2": `VendorCustomTable_dashboardcont2__+tK8K`
};
export default ___CSS_LOADER_EXPORT___;
